<template>
    <div>
        <v-card
            id="alternative-tabs"
            :class="{ 'hidden': !isOpenedNavbar }"
            flat
        >
            <v-container
                v-if="!isLoading"
                class="pa-0"
                fluid
            >
                <!-- <div v-show='isOpenedNavbar'> -->
                    <HeaderLayout 
                        v-if="hasHeader"
                        :data="data"
                        :goBack="goBack"
                        :backButton="backButton"
                        :isStandalone="isStandalone" 
                        :activeWidget="activeWidget || null"
                        @toggle-search-route="toggleSearchRoute" 
                    />
                    <v-toolbar
                        v-if="hasBody" 
                        flat
                    >
                        <BodyLayout :data="data"/>  
                    </v-toolbar>

                    <FooterLayout 
                        v-if="hasFooter"
                        :data="data"
                        :showSearchRoute="showSearchRoute"
                        :startedWidget="startedWidget"
                        @toggle-search-route="toggleSearchRoute" 
                    />
                <!-- </div> -->
            </v-container>

            <v-sheet v-show="isLoading">
                <v-skeleton-loader
                    v-if='hasHeader'
                    class="pa-2"
                    type="table-heading"
                />
                <v-skeleton-loader
                    v-if='hasBody'
                    class="pa-2"
                    type="table-row-divider, divider"
                />
            </v-sheet>
        </v-card>

        <v-tooltip
            v-if="!isLoading && hasSidebar"
            right
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    id='navbar-cta'
                    v-bind="attrs"
                    v-on="on"
                    fab
                    small
                    depressed
                    elevation="1"
                    class="ma-4 text-none"
                    :class="{ 'pulse navbar-hidden': !isOpenedNavbar }"
                    @click.prevent="toggleNavbar"
                >
                    <v-icon>
                        {{ isOpenedNavbar ? 'mdi-chevron-double-up' : 'mdi-chevron-double-down' }} 
                    </v-icon>
                </v-btn>
            </template>
            <span>
                {{ isOpenedNavbar ? $t('alternative.hideNavbar') : $t('alternative.showNavbar') }}
            </span>
        </v-tooltip>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    import HeaderLayout from '@/layout/alternative/layout/HeaderLayout';
    import BodyLayout from '@/layout/alternative/layout/BodyLayout';
    import FooterLayout from '@/layout/alternative/layout/FooterLayout';

    export default {
        name: "AlternativeTabs",
        components:{
            HeaderLayout,
            BodyLayout,
            FooterLayout
        },
        data: () => ({
            widgetsWithSpecificNavbar: [
                'plot',
                'models',
                'conf-models',
                'documentation',
                'general'
            ],
            widgetsWithFooter: [
                'cutaway',
                'map',
                'configurable-tour'
            ],
            widgetWithoutHeaderOnStandalone: [
                'drone-view',
                'drone-floor-view',
                'conf-models'
            ],
            showSearchRoute: false,
            isReady: false
        }),
        props: {
            data: {
                type: Object,
                required: true
            },
            backButton: {
                type: Boolean,
                default: false
            },
            goBack: {
                type: Function,
                default: null
            },
            isStandalone: {
                type: Boolean,
                default: false
            }
        },
        created() {
            this.setIsLoading(true);
        },
        computed: {
            ...mapGetters([
                'isLoading',
                'startedWidget',
                'isOpenedNavbar',
                'hasSidebar'
            ]),
            hasHeader() {
                return !_.isEmpty(this.data) && !(this.isStandalone && this.widgetWithoutHeaderOnStandalone.includes(this.data.type));
            },
            hasBody(){
                if (_.isEmpty(this.data)) 
                    return false;
                else if(this.data.activeHotspot && this.data.type === 'program' && !this.data.levels)
                    return false;
                else if (this.startedWidget === 'program' && this.data.type !== 'configurable-tour') 
                    return true;
                else
                    return this.widgetsWithSpecificNavbar.includes(this.data.type);
            },
            hasFooter() {
                return this.widgetsWithFooter.includes(this.data.type);
            },
            activeWidget(){
                return this.navigationItemList ? this.navigationItemList.find(widget => widget.active == true) : {};
            },
            navigationItemList() {
                if (this.startedWidget === 'program' && !this.widgetsWithSpecificNavbar.includes(this.data.type)) {
                    return this.data.levels || this.data.widgetList;
                } else {
                    switch (this.data.type) {
                        case 'general':
                            return this.data.levels;
                        case 'plot':
                        case 'models':
                            return this.data.items;
                        case 'documentation':
                            return this.data.documents;
                        default:
                            if (this.data.widgetType === 'general') {
                                return this.data.levels;
                            }
                            return null;
                    }
                }
            }
        },
        methods: {
            ...mapActions([
                'setIsLoading',
                'toggleNavbar'
            ]),
            toggleSearchRoute(){
                this.showSearchRoute = !this.showSearchRoute;
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/layout/alternative/AlternativeTabs.vue